export const saveToLocalStorage = (key, data, options) => {
  const filteredData = { ...data };

  if (options && options.blacklist) {
    options.blacklist.forEach((item) => {
      delete filteredData[item];
    });
  }

  const serializedData = JSON.stringify(filteredData);
  localStorage.setItem(key, serializedData);
};

export const loadFromLocalStorage = (key) => {
  const serializedData = localStorage.getItem(key);
  try {
    return JSON.parse(serializedData) || {};
  } catch (error) {
    console.warn(`Error parsing localStorage data for key "${key}":`, error);
    return {};
  }
};
